import { DECIMAL_PLACES } from '@/src/constants';
import { isString } from '@/src/helpers';
import { Amount, BookOffer, dropsToXrp } from 'xrpl';
import { OfferType } from '../orderbook.types';

/**
 * Custom hook to calculate the values to display of an offer
 * @param offer BookOffer object
 * @param offerType OfferType (buy or sell)
 * @returns amount, total, price
 */
export const useOfferValues = (offer: BookOffer, offerType: OfferType) => {
  const { TakerGets, TakerPays } = offer;

  const isBuy = offerType === 'buy';

  const amount = getValue(isBuy ? TakerPays : TakerGets);
  const total = getValue(isBuy ? TakerGets : TakerPays);
  const price = (Number(total) / Number(amount)).toFixed(DECIMAL_PLACES);

  return { amount, total, price };
};

/**
 * Get the value of an offer and format it to the decimal places
 * @param val IssuedCurrency or string
 * @returns A string formatted to the decimal places for IOU or the XRP amount (not drops)
 */
const getValue = (val: Amount) =>
  isString(val) ? Number(dropsToXrp(val)).toFixed(DECIMAL_PLACES) : Number(val.value).toFixed(DECIMAL_PLACES);
